import React, { useEffect } from "react";
import { Grid } from "@material-ui/core";
import FilterTogglebar from "../common/FilterTogglebar";
import TribesView from "./TribesView";
import TribesViewResponsive from "./TribesViewResponsive";
// import { tribes } from './constants';
// import { charts } from './constants';
import { useSelector } from "react-redux";
import userActions from "../common/actions";
import useGetViewPortDimensions from "hooks/useGetViewPortDimensions";

const TribesContainer = () => {
  const { loadTribes, setSelectedTribe, resetSelectedTribe } = userActions();
  const { tribes, tribe_selected, chart_selected } = useSelector((state) => state.water_user);
  const { loadTribalShortages } = userActions();
  const { loadTribeMetrics } = userActions();
  const { isMobile } = useGetViewPortDimensions();

  const componentMount = () => {
    loadTribes();
    loadTribalShortages(1, 1);
    loadTribeMetrics(1);
    return () => {
      resetSelectedTribe();
    };
  }
  useEffect(componentMount, []);

  const handleChange = (tribe_value, scenario_value) => {
    setSelectedTribe(tribes[tribe_value - 1]);
    loadTribalShortages(scenario_value, tribe_value);
    loadTribeMetrics(tribe_value);
  };

  return (
    <Grid container>
      {!isMobile ? <FilterTogglebar
        options={tribes}
        title={`Community: ${tribe_selected.name}`}
        handleChange={handleChange}
        value={tribe_selected.tribe_id}
        scenario_disabled={chart_selected === 0 ? true : false }
      /> : null}
      {isMobile ? <TribesViewResponsive /> : <TribesView />}
    </Grid>
  );
};

export default TribesContainer;
